import { useMeContext } from '~/modules/me';
import { getTaskResourceUserAllocationsSummaryForUserQuery } from '~/modules/tasks/hooks/useGetTaskResourceUserAllocationsSummaryForUser';
import useResourcingChartToolbarContext from './useResourcingChartToolbarContext';

export const useRefetchQueriesOnTaskAllocationModification = ({
  userId,
  projectId
}) => {
  const { permissionsMap } = useMeContext();
  const { dateRange } = useResourcingChartToolbarContext();

  const isCompleteResourceAllocationEditEnabled = Boolean(
    permissionsMap['urn:replicon-webui:completed-resource-allocation:edit']
  );

  return [
    getTaskResourceUserAllocationsSummaryForUserQuery({
      userId,
      projectId,
      dateRange
    }),
    ...(isCompleteResourceAllocationEditEnabled
      ? ['getProjectTotalsBySlug']
      : [])
  ];
};
